module.exports = __webpack_public_path__ + "img/no-data.fa92098.svg";